'use strict';

var debug = require('debug');

var log = debug('jsipfs:mfs-preload');
log.error = debug('jsipfs:mfs-preload:error');

module.exports = function (self, options) {
  options = options || {};
  options.interval = options.interval || 30 * 1000;
  var rootCid;
  var timeoutId;

  var preloadMfs = function preloadMfs() {
    self.files.stat('/', function (err, stats) {
      if (err) {
        timeoutId = setTimeout(preloadMfs, options.interval);
        return log.error('failed to stat MFS root for preload', err);
      }

      if (rootCid !== stats.hash) {
        log("preloading updated MFS root ".concat(rootCid, " -> ").concat(stats.hash));
        return self._preload(stats.hash, function (err) {
          timeoutId = setTimeout(preloadMfs, options.interval);
          if (err) return log.error("failed to preload MFS root ".concat(stats.hash), err);
          rootCid = stats.hash;
        });
      }

      timeoutId = setTimeout(preloadMfs, options.interval);
    });
  };

  return {
    start: function start(cb) {
      self.files.stat('/', function (err, stats) {
        if (err) return cb(err);
        rootCid = stats.hash;
        log("monitoring MFS root ".concat(rootCid));
        timeoutId = setTimeout(preloadMfs, options.interval);
        cb();
      });
    },
    stop: function stop(cb) {
      clearTimeout(timeoutId);
      cb();
    }
  };
};